module.exports = __webpack_public_path__ + "images/3681aaa0eef28518a17f8886d2fac804.svg";